import { IonIcon, IonItem } from "@ionic/react";
import { api } from "@/lib/backend";
import { type Document } from "@/lib/backend/api";
import { fileIcon } from "@/lib/icons/file.icon";
import { downloadFile } from "@/lib/utils/download";
import { logger } from "@/logger";

export function DocumentCard({ document, projectId }: { document: Document; projectId: string }) {
  const handleDownload = async () => {
    try {
      // Properly encode the document name for use in the URL path
      const encodedDocumentName = encodeURIComponent(document.name);
      const response = await api.file.getProjectDocumentUrl(projectId, encodedDocumentName);
      const url = response.data.url;

      await downloadFile(url, document.name);
    } catch (error) {
      logger.error("Failed to download document:", error);
    }
  };

  return (
    <IonItem
      button
      detail={true}
      onClick={handleDownload}
      className="ion-no-padding w-full rounded-2xl bg-surface-primary [--border-width:0] [--detail-icon-color:var(--ion-color-brand)] [--detail-icon-opacity:1] [--inner-padding-end:1rem] [--padding-start:1rem]"
      lines="none"
      style={{ "--background": "var(--ion-color-surface-primary)" }}
    >
      <IonIcon icon={fileIcon} slot="start" className="mr-3 size-6 p-2 text-txt-brand" />
      <span className="text-md font-medium text-txt-brand">{document.name}</span>
    </IonItem>
  );
}
